export let insRegistrationViewHeader = [
    {prop: 'name', label: '机构名称'},
    {prop: 'sysTypeText', label: '注册通道'},
    {prop: 'provinceName', label: '省份'},
    {prop: 'address', label: '收件地址'},
    {prop: 'comTypeText', label: '机构类型'},
    {prop: 'comCode', label: '纳税人识别号'},
    {prop: 'connectName', label: '联系人'},
    {prop: 'connectPhone', label: '手机号'},
    {prop: 'email', label: '邮箱'},
]
